import axios from '@axios';

const baseUrl = '/vendor-products';

export default {
  getVendorProducts(filters, vendorstr, productstr) {
    return axios.get(`${baseUrl}?vendor=${vendorstr}&product=${productstr}`);
  },
};
